import React from 'react';
import { supabase } from '../supabase';
import { useEffect } from 'react';
import { useState } from 'react';
import { useRef } from 'react';
import './sec4-p3.css'
import Input from '../components/common/input';
import Textarea from '../components/common/textarea';
import Ticketnum from '../components/common/ticketnumb';
import pic50 from'../assets/pic50.png'
import Errormsginput from '../components/common/errormsginput';


const Sec4p3 = ({ bookingData, setBookingData , errors }) => {
    const [headers, setheaders]= useState([]);

        useEffect(() => {
        const getheaders = async()=>{
            const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
        setheaders(res.data);
        }
        getheaders();
        }, []);



 const secRef = useRef(null);


useEffect(() => {


  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, []);


const [dates, setDates]= useState([]);



useEffect(() => {
  const getDates = async () => {
    const res = await supabase
      .from("exbition_event")
      .select("id, start_date, end_date, status")
      .eq("status", "ongoing")
      .limit(1);

    const event = res.data?.[0];

    if (!event) return;

    setBookingData(prev => ({
      ...prev,
      eventId: event.id
    }));

    const start = new Date(event.start_date);
    const end = new Date(event.end_date);

    const daysArray = Array.from(
      { length: Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1 },
      (_, i) => {
        const date = new Date(start);
        date.setDate(start.getDate() + i);
        return date;
      }
    );

    setDates(daysArray);
  };

  getDates();
}, []);












    return ( 
        <section className='sec4-p3' ref={secRef}>
            <section className='container-sec4-p3'>
                    <h1 className='header-sec4-p3'>{headers?.[15]?.header}</h1>
                    <form className='form-sec4-p3'>
                        <fieldset className='sub-container-sec4-p3'>
                               <Input title='Full Name' 
                               type='text'
                                    placeholder='Enter your name' 
                                       onChange={(e) =>
                                      setBookingData(prev => ({
                                        ...prev,
                                        user: {
                                          ...prev.user,
                                          name: e.target.value
                                        }
                                      }))
                                    }/>
                                    <Errormsginput message={errors.name} />

                               <Input title='Email Address' 
                               type='text'
                                    placeholder='Enter your email'
                                    onChange={(e) =>
                                        setBookingData(prev => ({
                                          ...prev,
                                          user: {
                                            ...prev.user,
                                            email: e.target.value
                                          }
                                        }))
                                      }
                                     />

                                     <Errormsginput message={errors.email} />

                               <Input title='Phone Number' 
                               type='text'
                                    placeholder='Phone phone number'
                                      onChange={(e) =>
                                      setBookingData(prev => ({
                                        ...prev,
                                        user: {
                                          ...prev.user,
                                          phone: e.target.value
                                        }
                                      }))
                                    } />
                                     <Errormsginput message={errors.phone} />


        <fieldset className='container-input'>
            <label className='title-inputt'>Select date</label>


                                  <div className="select-wrapper">
                                  <select
                                    className="inputts"
                                    onChange={(e) =>
                                      setBookingData(prev => ({
                                        ...prev,
                                        date: e.target.value
                                      }))
                                    }
                                  >
                                    <option value="">Select Date</option>

                                    {dates.map((date, i) => (
                                      <option key={i} value={date.toISOString()}>
                                        {date.toDateString()}
                                      </option>
                                    ))}
                                  </select>

                                  <img src={pic50} className="select-arrow" alt="dropdown" />
                                </div>
                    <Errormsginput message={errors.date} />

        </fieldset>







                            <Ticketnum  title='Number of Tickets'
                          value={bookingData.quantity}
                          onChange={(value) =>
                            setBookingData(prev => ({
                              ...prev,
                              quantity: value
                            }))
                          }
                        />
                          <Errormsginput message={errors.quantity} />


                        </fieldset>

                        <fieldset className='sub-container-sec4-p3'>
                               <Input title='Job Title' 
                               type='text'
                                    placeholder='Enter your job title' 
                                     onChange={(e) =>
                                    setBookingData(prev => ({
                                      ...prev,
                                      user: {
                                        ...prev.user,
                                        job_title: e.target.value
                                      }
                                    }))
                                  } />

                               <Input title='Company / organization ' 
                               type='text'
                                    placeholder='Enter your company name'
                                     onChange={(e) =>
                                    setBookingData(prev => ({
                                      ...prev,
                                      user: {
                                        ...prev.user,
                                        company_name: e.target.value
                                      }
                                    }))
                                  } />

                                 

                                <Textarea title='Address' type='text'
                                stylee='textareaa2'
                                     placeholder='Enter your address'
                                     onChange={(e) =>
                                        setBookingData(prev => ({
                                          ...prev,
                                          user: {
                                            ...prev.user,
                                            address: e.target.value
                                          }
                                        }))
                                      }
                                     />

                        </fieldset>


                    </form>
            </section>
        </section>
     );
}
 
export default Sec4p3;